import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import type { SearchInfoData } from '@/app/search/types';
import { getOpenTelemetryTraceIdFromTraceparent } from '@/utils/traceIdUtils';

export const DP_SHOWN_FLIGHTS = 'DP_SHOWN_FLIGHTS';
export const DP_SHOWN_FLIGHTS_VERSION = '1.1';

export type FlightDetail = {
  tripId: string;
  resultPosition: number;
  totalPrice: number;
  currency: string;
  isDefaultFlightFlag: boolean;
};

export type DpShownFlightsParams = {
  searchInfoData: SearchInfoData;
  initialParams: InitialParams;
  selectedMealPlan: MealPlanType;
  availableTransports: AvailableTransport[];
  defaultFlightId: string;
  currentSorting: string;
  currency: string;
};

export type DpShownFlightsPayload = {
  ot_traceId: string;
  searchId: string;
  productDetailKey: string;
  internalHotelId: string;
  rateId: string;
  resultQty: number;
  sorting: string;
  flightResults: FlightDetail[];
};

export const createDpShownFlightsPayload = (params: DpShownFlightsParams): DpShownFlightsPayload => {
  const {
    searchInfoData,
    initialParams,
    selectedMealPlan,
    availableTransports,
    defaultFlightId,
    currentSorting,
    currency,
  } = params;

  const flightResults = availableTransports.map((transport, index) => ({
    tripId: transport.id,
    resultPosition: index + 1,
    totalPrice: transport.price,
    currency,
    isDefaultFlightFlag: transport.id === defaultFlightId,
  }));

  const payload = {
    ot_traceId: searchInfoData?.searchTraceParent
      ? getOpenTelemetryTraceIdFromTraceparent(searchInfoData.searchTraceParent)
      : '',
    searchId: initialParams.hdpSearchId,
    productDetailKey: initialParams.productDetailKey,
    internalHotelId: `${initialParams.internalHotelId}`,
    rateId: selectedMealPlan.id,
    resultQty: availableTransports.length,
    sorting: currentSorting,
    flightResults,
  };

  return payload;
};
